const TRACKER_ID = 'UA-51313571-6';

export class Ga {

    private _ga: any;

    constructor(accessType:string = 'unknown') {
        const ga = (<any>window).ga || ((...args) => {});
        ga('create', {
            trackingId: TRACKER_ID,
            name: 'player',
            cookieDomain: 'auto'
        });

        this._ga = (...args) => ga(...args);
        this.ga('set', 'dimension1', accessType);
        this.ga('set', 'dimension2', document.location.host);
        this.ga('send', 'pageview');
    }

    private ga(action, ...args) {
        this._ga(`player.${action}`, ...args);
    }

    public sendEvent(...args) {
        this.ga('send', 'event', ...args);
    }

}